export const LENDERS_SET_ALL = 'LENDERS_SET_ALL';

export const mutations = {
  [LENDERS_SET_ALL](state, value) {
    state.lenders = value;
  },
};
